import en from "./en";
import fa from "./fa";

/**
 * @created        16/09/2023 - 16:10
 * @author         Nariman Palangi
 * @user           ragnarok
 * @organization
 * @project        boilerplate-vue-3
 * @file name      index.js
 * @file dir       src/locales
 */
export default {
    en: en,
    fa: fa,
}